import CryptoJS from 'crypto-js';

const Security = {
    encryptContent(content) {
        if (process.env.NODE_ENV === 'development') {
            return content;
        }

        if (content === null || content === undefined) {
            return '';
        }

        try {
            const text =
                typeof content === 'string'
                    ? content
                    : JSON.stringify(content);

            return CryptoJS.AES.encrypt(
                text,
                process.env.VUE_APP_AES_SECRET_KEY
            ).toString();

        } catch (err) {
            console.error('❌ encryptContent error:', err);
            return '';
        }
    },

    decryptContent(encryptedContent) {
        if (process.env.NODE_ENV === 'development') {
            return encryptedContent;
        }

        if (!encryptedContent || encryptedContent.length < 16) {
            return null;
        }

        try {
            // Detecta si NO es base64 válido → entonces no lo intentes descifrar
            if (!/^[A-Za-z0-9+/=]+$/.test(encryptedContent)) {
                return null;
            }

            const bytes = CryptoJS.AES.decrypt(
                encryptedContent,
                process.env.VUE_APP_AES_SECRET_KEY
            );

            const decrypted = bytes.toString(CryptoJS.enc.Utf8);

            if (!decrypted) return null;

            return decrypted;

        } catch (error) {
            console.error('⛔ Error decrypting content:', error);
            return null;
        }
    }
};

export default Security;